<script>
import Sms from './Sms.vue';

export default {
  components: { Sms },
};
</script>

<template>
  <Sms type="whatsapp" />
</template>
